// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"570ad59c","547":"37a25387"}[chunkId] + ".chunk.css";
};